export * from "./collections.ts";
export * from "./content.tsx";
export * from "./date.ts";
export * from "./images.ts";
export * from "./language.ts";
export * from "./localStorage.ts";
export * from "./offer.ts";
export * from "./styles.ts";
export * from "./subtitles.ts";
export * from "./user.ts";
export * from "./validation.ts";
export * from "./videos.ts";

export const sortByArray = (a: unknown, b: unknown, array: unknown[]) => {
  const indexA = array.indexOf(a);
  const indexB = array.indexOf(b);

  if (indexA === -1 && indexB === -1) {
    return 0;
  } else if (indexA === -1) {
    return 1;
  } else if (indexB === -1) {
    return -1;
  } else {
    return indexA - indexB;
  }
};

export const toPascalCase = (str: string) =>
  str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
    .join(" ");

export const slugify = (input: string): string => {
  return input
    .split("/") // Split the string into segments
    .map(
      (segment) =>
        segment
          .toString()
          .normalize("NFKD") // Convert characters to their base form
          .replace(/[\u0300-\u036f]/g, "") // Remove diacritics (accent marks)
          .toLowerCase()
          .trim() // Remove leading/trailing whitespace
          .replace(/[^a-z0-9]+/g, "-") // Replace special chars/spaces with `-`
          .replace(/--+/g, "-") // Collapse multiple dashes into one
          .replace(/^-+|-+$/g, ""), // Remove leading/trailing dashes from segment
    )
    .filter(Boolean) // Remove empty segments (e.g. multiple slashes like `//blah`)
    .join("/") // Join the segments back into a string
    .replace(/^\/+/, ""); // Remove any leading slash from full path
};
